import { object } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({})

export const url = () => `/v1/policies`
